import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import TitlePlaceholder from '../TitlePlaceholder';
import s from './SidebarBlock.scss';
export var SidebarBlock = function (_a) {
    var streamKey = _a.streamKey, titleOverride = _a.titleOverride, seeAll = _a.seeAll, children = _a.children, className = _a.className, titleClassname = _a.titleClassname, headerClassname = _a.headerClassname, isLoading = _a.isLoading;
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement("div", { className: classnames(s['block-header'], !titleOverride && s['original-title'], headerClassname) },
            React.createElement("span", { className: classnames(s['block-title'], titleClassname) },
                !isLoading &&
                    (titleOverride || t("sidebar.blockTitle." + streamKey)),
                isLoading && React.createElement(TitlePlaceholder, null)),
            seeAll && (React.createElement(BiLink, { className: s['see-all'], href: seeAll.href, onClick: seeAll.onClick, biData: __assign({ evid: BiEventType.SEE_ALL_CLICK }, seeAll.biData) }, t(["sidebar.seeAll." + streamKey, "sidebar.seeAll"])))),
        children));
};
SidebarBlock.displayName = 'SidebarBlock';
export default SidebarBlock;
//# sourceMappingURL=SidebarBlock.js.map